import { createDefaultTyrann, objectError } from '@apis/common';
import { checklist, patchChecklist } from '@models/Checklist';
import {
  companyItem,
  companyMemberNo,
  dashboardCompanyQuery,
  companyDetails,
  patchCompanyBody,
} from '@models/Company';
import { delegation } from '@models/Delegation';
import { onlineDocument } from '@models/OnlineDocument';
import { adminUser, patchCompanyPrincipal, patchCompanyStaff } from '@models/User';
import * as t from 'io-ts';
import * as h from 'tyrann-io';

export const companyApis = createDefaultTyrann({
  '/dashboard/company/': {
    get: {
      query: dashboardCompanyQuery,
      response: {
        200: t.type({
          count: t.number,
          results: t.array(companyItem),
        }),
      },
    },
  },
  '/dashboard/company/{id}/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: companyItem,
      },
    },
  },
  '/dashboard/company/{id}/detail/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: companyDetails,
      },
    },
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchCompanyBody,
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/company/{id}/owner/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: adminUser,
      },
    },
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchCompanyPrincipal,
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
        409: t.type({
          email_duplicate_error: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/company/{id}/checklist/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: checklist,
      },
    },
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchChecklist,
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/company/overview/': {
    get: {
      response: {
        200: t.type({
          today_count: t.number,
          unassigned_count: t.number,
          assigned_count: t.number,
          today_assigned_count: t.number,
        }),
      },
    },
  },
  '/dashboard/company/{id}/salesperson/': {
    post: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/company/{id}/pass/': {
    post: {
      path: t.type({
        id: t.number,
      }),
      response: {
        201: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/company/{id}/member-no/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: companyMemberNo,
      },
    },
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: companyMemberNo,
      response: {
        200: t.type({}),
        400: t.type({
          non_field_errors: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/company/{id}/delegation/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: delegation,
      },
    },
  },
  '/dashboard/company/{id}/k01/': {
    get: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: onlineDocument,
      },
    },
    post: {
      path: t.type({
        id: t.number,
      }),
      response: {
        200: t.type({}),
        400: objectError,
      },
    },
  },
  '/dashboard/company/staff/{id}/': {
    patch: {
      path: t.type({
        id: t.number,
      }),
      body: patchCompanyStaff,
      response: {
        200: t.type({}),
        409: t.type({
          email_duplicate_error: h.omittable(t.array(t.string)),
        }),
      },
    },
  },
  '/dashboard/company/staff/resend-email/': {
    post: {
      body: t.type({
        email: t.string,
      }),
      response: {
        200: t.type({}),
      },
    },
  },
});
